module.exports = __webpack_public_path__ + "img/circle_icon_2.4cb7434.svg";